export const ROOT_PATH = '/';
export const LOGIN_PATH = '/login';
export const ORDERS_PATH = '/orders';
export const REPORTS_PATH = '/reports';
export const REPORTS_NEW_PATH = '/reports/new';
